<template>
	<div class="mobile-menu-component">
		<div class="dropdown-link" role="navigation">
			<div class="menu-search" v-bind:class="{ open: isOpenSearch }" v-on:click="toggleMenuSearch">
				<span class="glyphicon glyphicon-search IconSearch" aria-hidden="true"></span>
			</div>
			<div class="menu-icon" v-bind:class="{ open: isOpen }" v-on:click="toggleMenu">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
		<transition name="dropdown" mode="out-in">
			<div class="dropdown-content" v-if="isOpenSearch">
				<ul class="help-menu">
					<li>
						<div class="media">
							<div>
								<search id="search_input" class="search" name="query" value="" place="Ej: Certificado de nacimiento" title=""></search>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="dropdown-content" v-if="isOpen">
				<div class="scroll">
					<ul class="help-menu">
						<li v-if="user" class="menu-ciudadano-global">
							<!--Submenú Mi ChileAtiende-->
							<div><li>
								<div class="sub-group" style="width: auto;">
									<div class="sub-group-heading">Mi ChileAtiende</div>                                
								</div>
							</li></div>
							<div><a href="/mi-cha/inicio" title="Ir a novedades" class="help-card micha">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-novedades"> </span></div>
									<div class="media-body">
										<div class="media-heading">Bienvenida</div>
									</div>
								</div>
							</a></div>
							<div><a href="/mi-cha/certificados" title="Ir a certificados" class="help-card micha">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-certificados"> </span></div>
									<div class="media-body">
										<div class="media-heading">Certificados</div>
									</div>
								</div>
							</a></div>
							<div><a  v-if="this.mostrar_beneficios" href="/mi-cha/mis-beneficios" title="Ir a mis beneficios" class="help-card micha">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-beneficios"> </span></div>
									<div class="media-body">
										<div class="media-heading">Mis beneficios</div>
									</div>
								</div>
							</a></div>
							<!--<div><a  href="/mi-cha/notificaciones" title="Ir a mis notificaciones" class="help-card micha"><div class="media"><div class="media-left"><i class="fas fa-envelope"></i></div> <div class="media-body"><div class="media-heading">Mis notificaciones <span class="notification-badge" style="color:#ffffff; font-size:11px;">{{ cantidadNoleidos }}</span></div></div></div></a></div>-->
							<div><a href="/mi-cha/mis-recordatorios" title="Ir a recordatorios" class="help-card micha">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-recordatorios"> </span></div>
									<div class="media-body">
										<div class="media-heading">Mis recordatorios</div>
									</div>
								</div>
							</a></div>
							
							<div><a href="/mi-cha/perfil" title="Ir a mis datos personales" class="help-card micha">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-datos"> </span></div>
									<div class="media-body">
										<div class="media-heading">Mis datos</div>
									</div>
								</div>
							</a></div>

							<div><a href="/mi-cha/historial" title="Mi historial" class="help-card micha">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-historial"> </span></div>
									<div class="media-body">
										<div class="media-heading">Mi historial</div>
									</div>
								</div>
							</a></div>

							<div><a href="/mi-cha/ciudadanologout" target="_top" title="Cerrar sesión" class="help-card micha" onclick="event.preventDefault(); app.logoutCU();">
								<div class="media" style="border-bottom:0px">
									<div class="media-left"><span class="icon icon-cerrar_sesion"> </span></div>
									<div class="media-body">
										<div class="media-heading">Cerrar sesión</div>
										<form id="logout-form" action="mi-cha/ciudadanologout" method="POST" style="display: none;">
											<input type="hidden" name="_token" v-model="token">
										</form>
									</div>
								</div>
							</a></div>

							<div><a href="/mi-cha/#" title="Ayuda" class="help-card micha">
								<div class="media">
									<div class="media-left"><span class="icon icon-ayuda"> </span></div>
									<div class="media-body">
										<div class="media-heading">¿Necesitas ayuda?</div>
									</div>
								</div>
							</a></div>
						</li>
						<li v-show="ocultarMicha==false">
							<a v-if="user == null" href="/login/claveunica" title="Ir a Mi Chile Atiende" class="help-card">
								<div class="media"><div class="media-left what-is-it">
									<img src="images/ico-chileatiende.gif" alt="Ícono Chileatiende" class="ico-top-xs">
								</div>
									<div class="media-body">
										<div class="media-heading">Mi ChileAtiende: Iniciar sesión</div>
										<!-- <p>Conoce los beneficios que te pueden interesar.</p> -->
									</div>
								</div>
							</a>
						</li>
						<li>
							<a href="/que-es-chileatiende" class="help-card" title="Ir a qué es ChileAtiende">
								<div class="media">
									<div class="media-left what-is-it">
										<i class="material-icons">help</i>
									</div>
									<div class="media-body">
										<div class="media-heading">¿Qué es ChileAtiende?</div>
										<p>Información sobre la Guía de Trámites y Servicios del Estado.</p>
									</div>
								</div>
							</a>
						</li>
						
						
						<li>
							<a href="/ayuda/preguntas-frecuentes" class="help-card" title="Ir a preguntas frecuentes">
								<div class="media">
									<div class="media-left">
										<i class="material-icons">help</i>
									</div>
									<div class="media-body">
										<div class="media-heading">Preguntas Frecuentes</div>
										<p>Revisa la lista de preguntas frecuentes.</p>
									</div>
								</div>
							</a>
						</li>	
						<li>
							<a href="https://formulario.chileatiende.cl/FormularioCha/" target="_blank" class="help-card" title="ir a contacto">
								<div class="media">
									<div class="media-left">
										<i class="material-icons">mail</i>
									</div>
									<div class="media-body">
										<div class="media-heading">Contáctenos</div>
										<p>Ir al formulario de contacto.</p>
									</div>
								</div>
							</a>
						</li>
						<!-- sub grouped content for social links -->
                        <li>
                            <div class="sub-group" style="width: auto;">
                                <div class="sub-group-heading">Redes Sociales</div>                                
                            </div>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/ChileAtiende" target="_blank" class="help-card" title="Ir a Facebook">
                                <div class="media" style="border-bottom:0px">
                                    <div class="media-left">
                                        <img src="images/facebook_red-new.svg" alt="Logotipo de Facebook" />
                                    </div>
                                    <div class="media-body">
                                        <div class="media-heading">Facebook</div>                                        
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/ChileAtiende" target="_blank" class="help-card" title="Ir a Twitter">
                                <div class="media" style="border-bottom:0px">
                                    <div class="media-left">
                                        <img src="images/twitter_red-new.svg" alt="Logotipo de Twitter" />
                                    </div>
                                    <div class="media-body">
                                        <div class="media-heading">Twitter</div>                                        
                                    </div>
                                </div>
                            </a>
                        </li>
						<li>
                            <a href="https://www.instagram.com/chileatiende/" target="_blank" class="help-card" title="Ir a Instagram">
                                <div class="media">
                                    <div class="media-left">
                                        <img src="images/instagram_red.svg" alt="Logotipo de Instagram" />
                                    </div>
                                    <div class="media-body">
                                        <div class="media-heading">Instagram</div>                                        
                                    </div>
                                </div>
                            </a>
                        </li>
                        <!-- end social links -->					
						<li>
							<a href="/ayuda/sucursales" class="help-card" title="ir a sucursales">
								<div class="media">
									<div class="media-left">
										<i class="material-icons">store</i>
									</div>
									<div class="media-body">
										<div class="media-heading">Sucursales</div>
										<p>Busca tu sucursal de ChileAtiende más cercana.</p>
									</div>
								</div>
							</a>
						</li>
						<li>
							<a href="/ayuda/oficinas-moviles" class="help-card">
								<div class="media">
									<div class="media-left">
										<i class="material-icons">directions_bus</i>
									</div>
									<div class="media-body">
										<div class="media-heading">Oficinas Móviles</div>
										<p>Conoce la ubicación de nuestras oficinas móviles.</p>
									</div>
								</div>
							</a>
						</li>
                        <li>
							<a href="/ayuda/atencion-telefonica" class="help-card" title="Ir a atención telefónica">
								<div class="media">
									<div class="media-left">
										<i class="material-icons">perm_phone_msg</i>
									</div>
									<div class="media-body">
										<div class="media-heading">Atención Telefónica</div>
										
									</div>
								</div>
							</a>
						</li>
						<li>
							<a href="/ayuda/maa" class="help-card">
								<div class="media">
									<div class="media-left">
										<i class="material-icons">alternate_email</i>
									</div>
									<div class="media-body">
										<div class="media-heading">Módulos de Autoatención</div>
										<p>Conoce los servicios disponibles.</p>
									</div>
								</div>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</transition>
	</div>
</template>
<style lang="scss">

	$red: #ED3232;
	.scroll{
		max-height: 500px;
		overflow: scroll;
		background: lightgrey;
	}
	.IconSearch{
		font-size:24px;
		color: #ffffff;

	}
	.menu-search {
		position: relative;
		height: 30px;
		margin-top: 25px;
		margin-right: 20px;
		display: inline-block !important;
		margin-right: 20px;
		vertical-align: 9px;
	}
	.menu-icon {
		position: relative;
		height: 30px;
		margin-top: 25px;
		margin-right: 20px;
		display: inline-block;
		span {
			height: 4px;
			width: 30px;
			display: block;
			transition: .3s ease;
			background-color: #ffffff !important;
			&:nth-child(2) {
				margin-top: 4px;
			}
			&:nth-child(3) {
				margin-top: 4px;
			}
		}
		&.open {
			span {
				&:nth-child(1) {
					transform: rotate(45deg);
					margin-top: 6px;
				}
				&:nth-child(2) {
					opacity: 0;
				}
				&:nth-child(3) {
					transform: rotate(-45deg);
					margin-top: -12px;
				}
			}
		}
	}
	.dropdown-content {
		width: 100%;
		position: absolute;
		top: 70px;
		text-align: left;
		//transform: translate(0,0);
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
		.help-menu {
			padding: 0;
			margin: 0;
			list-style-type: none;
			.media {
				width: 100%;
			}
			.mcha-mobile {
				background-color: #004A96;
				border-bottom: 0;
				.media-left {
					vertical-align: middle;
				}
				.media-heading {
					color: #fff;
					margin: 0;
					line-height: 1.2;
				}
				.material-icons {
					position: absolute;
					right: 10px;
					top: 25px;
					color: #fff;
				}
			}
			.user-options {
				a {
					display: block;
					color: #fff;
					background-color: #0053AB;
					border-bottom: 1px solid #00458D;
					padding: 13px;
					.material-icons {
						font-size: 20px;
						vertical-align: bottom;
					}
				}
			}
		}
	}
	.dropdown-enter-active, .dropdown-leave-active {
		transition: .2s ease;
	}
	.dropdown-enter, .dropdown-leave-to {
		opacity: 0;
	}
</style>
<script>
	import HomeSidebar from "./HomeSidebar";
	import Search from './Search.vue';
	
    export default {
        components: {HomeSidebar,Search},
        props: ['user', 'ocultar-micha' , 'mostrar_beneficios'],
        data: function() {
            return {
				isOpen: false,
				isOpenSearch: false,
                cantidadNoleidos: null,
                token:  document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        },
        methods: {
            toggleMenu: function() {
				this.isOpenSearch = false;
                this.isOpen = ! this.isOpen;
            },
			toggleMenuSearch: function(){
				this.isOpen = false;
				this.isOpenSearch = ! this.isOpenSearch;
			},
            scrollToEnd: function() {
                var container = document.querySelector(".scroll");
            }
        },
        mounted() {
           
                        self.cantidadNoleidos = 0;
                  
        }
    }
</script>
